export default __webpack_public_path__ + "static/media/(15).697dcc38.jpg";